export default __webpack_public_path__ + "static/air-conditioning-service-repair-minnesota-de2f96efd5bef754b793d49dd709a257.jpg";